import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  constructor(private http: HttpClient) { }

  private apiUrl = '';

  getBillHistory() {
    return this.http.get(`${this.apiUrl}/subscriptions/invoices`);
  }

  getCustomerOrders(customerId: string, paramsObj?: any) {
    let params = new HttpParams();

    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        const value = paramsObj[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return this.http.get(`${this.apiUrl}/orders/customer/${customerId}`, { params })
  }

  downloadInvoice(bill: any): any {
    return of({ success: true, message: "Invoice download initiated" });
    // return this.http.get(`${this.apiUrl}/subscriptions/invoices/${bill?._id}/download`);
  }

  getSubscriptions() {
    return this.http.get(`${this.apiUrl}/subscriptions`);
  }
  getPlans() {
    return this.http.get(`${this.apiUrl}/plans`);
  }

  getPlanDetails(planId: any) {
    // return this.http.get(`${this.apiUrl}/plans/${planId}`);
  }

  upgradePlan(data: any) {
    return this.http.post(`${this.apiUrl}/subscriptions/upgrade`, data);
  }

  createPlan(data: any) {
    return this.http.post(`${this.apiUrl}/orders`, data);
  }
}
